import React from 'react';
import ReactDOM from 'react-dom/client';
import AvertX360 from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AvertX360 />
  </React.StrictMode>
);
